export class TypeormExtensionError extends Error {

}
